<div class="container">
  <div class="formgrid grid">

    <div class="field col-2 p-fluid">
      <p-dropdown   [(ngModel)]="billCodeKey"    optionLabel="label" optionValue="value"  [options]="billCodeKeyOptions"  styleClass="p-text-left">
        </p-dropdown>
    </div>

    <div class="field col-12">
        <label>檔案</label>
        <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="preview($event)"  (onClear)="onClear()"
            chooseLabel="選擇" uploadLabel="預覽" cancelLabel="取消" accept=".xls,.xlsx"   >

          <ng-template pTemplate="toolbar">
            <button #uploadBtn pButton pRipple label="上傳"   class="p-button-success ml-1"  [disabled]="showUploadBtn()" (click)="upload()"></button>

          </ng-template>

          <ng-template pTemplate="content" let-files>
            <div >
              <p-table [value]="billSample"  [scrollable]="true" class="datatable" [style]="{ 'overflow-y': 'auto' }" [paginator]="true" [rows]="10"  >
                <ng-template pTemplate="body" let-row >
                  <tr>
                      <td *ngFor="let obj of row"  [ngStyle]="{'width':'200px'}" >{{obj}}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

          </ng-template>
        </p-fileUpload>
    </div>



  </div>
</div>
